module.exports = __webpack_public_path__ + "img/lily-banse--YHSwy6uqvk-unsplash.494ebef7.jpg";